import React, { useState, useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { PrimaryIconButton, SecondaryIconButton } from '../../theme/index';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { modalAction, modalDeleteAction } from '../../redux/reducers/Modal';
import SuccessModal from '../SuccessModal';
import DangerModal from '../DangerModal';
import { Pagination, PaginationItem, Grid } from '@mui/material';
import styled from '@mui/material/styles/styled';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const PaginationGrid = styled(Grid)(({ theme }) => `
    ul{
        justify-content: end
    }

    button:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)

const PaginationItemStyled = styled(PaginationItem)(({ theme }) => `
    svg{
        color: #000;
    }

    button:hover, svg:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)


function createData(id, cantity, details, unitPrice, totalPrice) {
    return { id, cantity, details, unitPrice, totalPrice };
  }

  const rows = [
    createData('001', 2, 'Gaseosa Coca-Cola - 1 Litro', 3.5, (3.5*2).toFixed(2)),
    createData('002', 3, 'Galleta - Festival (350g)', 2, (2*3).toFixed(2)),
    createData('003', 1, 'Pizza mediana (400g)', 12, (1*12).toFixed(2))
  ];


const SellProducts = () => {

    const [ clients, setClients ] = useState([]);
    const [ paginations, setPaginations ] = useState(0);
    const [ initResult, setInitResult ] = useState(0);
    const [ endResult, setEndResult ] = useState(10);
    const searchData = useSelector( state => state.Search.data );

    const [page, setPage] = React.useState(1);
    const handleChange = (event, value) => {
        if( page < value ){
            // aumentar
            setInitResult(initResult+10);
            setEndResult(endResult+10);
        }else{
            // disminuir
            setInitResult(initResult-10);
            setEndResult(endResult-10);
        }
        setPage(value);
    };

    useEffect( () => {
        const textToSearch = searchData.toLowerCase();
        setClients(rows);

        setPaginations(Math.ceil(rows.length/10))
    },[searchData, initResult, endResult] );

    const dispatch = useDispatch();
    const [ showModal, setShowModal ] = useState(false);
    const [ showDeleteModal, setShowDeleteModal ] = useState(false);
    const [ modalForm, setModalForm ] = useState('');
    const [ deleteModal, setDeleteModal ] = useState('');
    const modalStatus = useSelector( state => state.Modal.modalState );
    const deleteModalStatus = useSelector( state => state.Modal.deleteModalState );

    useEffect( () => {
        setShowModal(modalStatus);
      }, [modalStatus] );
    
    useEffect( () => {
        setShowDeleteModal(deleteModalStatus);
      }, [deleteModalStatus] );

    const editClient = () => {
        setDeleteModal('');
        dispatch(modalAction());
        setModalForm('editProduct');
    }

    const deleteClient = () => {
        setModalForm('');
        dispatch(modalDeleteAction());
        setDeleteModal('product');
    }

  return (
    <>
        {
            (showModal && modalForm !== '' ) &&
            <SuccessModal view={modalForm} />
        }
        {
            (showDeleteModal && deleteModal !== '' ) &&
            <DangerModal view={deleteModal} />
        }
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Cantidad</TableCell>
                    <TableCell>Detalles/ Especificaciones Técnicas</TableCell>
                    <TableCell>Precio unit.</TableCell>
                    <TableCell>Precio total</TableCell>
                    <TableCell align="center">Acciones</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {clients.map((row) => (
                    <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">{row.cantity}</TableCell>
                    <TableCell>{row.details}</TableCell>
                    <TableCell>{row.unitPrice}</TableCell>
                    <TableCell>{row.totalPrice}</TableCell>
                    <TableCell align="center">{
                        <>
                            <SecondaryIconButton aria-label="delete" onClick={ () => deleteClient() }>
                                <DeleteIcon />
                            </SecondaryIconButton>
                        </>
                    }</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>

        <Grid container sx={{ justifyContent: 'end', textAlign: 'end', mt: 2 }}>
            <PaginationGrid item xs={12}>
                <Pagination
                    count={paginations}
                    onChange={handleChange}
                    renderItem={(item) => (
                        <PaginationItemStyled
                        components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                        />
                    )}
                />
            </PaginationGrid>
        </Grid>
    </>
  )
}

export default SellProducts